import { render } from "./Myrecover_password.vue?vue&type=template&id=c532f058"
import script from "./Myrecover_password.vue?vue&type=script&lang=js"
export * from "./Myrecover_password.vue?vue&type=script&lang=js"

import exportComponent from "/media/whoami/010101010/Prosofty/PublicOpinion/frontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__